import {UI} from "../../../../../stem-core/src/ui/UIBase";

import {Messages} from "../../../../Messages";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";
import {BasePanelPage} from "../../../PanelPage";
import {MerchantButton} from "../../../../common/MerchantButton";
import {Router} from "../../../../../stem-core/src/ui/Router";
import {autoredraw} from "../../../../../stem-core/src/decorators/AutoRedraw";
import {UserAddressStore} from "../../../../../client/state/UserAddressStore";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {InlineUserDashboardPanelStyle} from "./InlineUserDashboardPanelStyle";
import {INLINE_USER_DASHBOARD_URLS} from "../../../PanelConstants";


@autoredraw(UserAddressStore)
@registerStyle(InlineUserDashboardPanelStyle)
export class InlineUserDashboardAddressInUsePanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.addressInUseTitle,
        };
    }

    render() {
        const {styleSheet} = this;

        return [
            <div>
                {Messages.addressInUseDashboard}
                <Link onClick={() => Router.changeURL(INLINE_USER_DASHBOARD_URLS.home)} value={Messages.here} className={styleSheet.link}/>.
            </div>,
            <MerchantButton label={Messages.ok} className={styleSheet.button} onClick={() => Router.back()}/>
        ];
    }
}
